"use client";

import { useEffect, useState } from "react";

export default function usePiBrowser() {
  const [isInPiBrowser, setIsInPiBrowser] = useState(null);

  useEffect(() => {
    if (typeof window === "undefined") {
      setIsInPiBrowser(false);
      return;
    }

    try {
      const ua = navigator.userAgent || "";
      const ref = document.referrer || "";

      // STRONG signals (preferred)
      const isPiUA = /pibrowser/i.test(ua);

      // Secondary signals (best-effort)
      const isPiReferrer = /minepi\.com/i.test(ref);
      const isPiPlatform = window.Pi?.platform === "pi_browser";

      setIsInPiBrowser(Boolean(isPiUA || isPiPlatform || isPiReferrer));
    } catch {
      setIsInPiBrowser(false);
    }
  }, []);

  return isInPiBrowser; // true | false | null
}
